export const derivePropertyKeys = stagedDealsUpdates => {
  const propertyKeys = new Set();
  Object.values(stagedDealsUpdates).forEach(updates => {
    Object.keys(updates).forEach(key => propertyKeys.add(key));
  });
  return [...propertyKeys];
};
export const stagedDealUpdateCount = stagedDealsUpdates => {
  let count = 0;
  Object.values(stagedDealsUpdates).forEach(updates => {
    Object.keys(updates).forEach(() => count++);
  });
  return count;
};